import { colors } from '@atlaskit/theme';
import type {
	DeploymentFrequencyReportWithProviderInfo,
	DeploymentFrequencyReportWeekData,
	IssuesPerDeploymentDataPoint,
} from '../../../common/types';

export const convertReportCoreToChartDataPoints = (
	deploymentFrequencyReportData: DeploymentFrequencyReportWithProviderInfo,
	selectedWeekStart: Date | null,
): IssuesPerDeploymentDataPoint[] =>
	deploymentFrequencyReportData.weeksData.map((weekData: DeploymentFrequencyReportWeekData) => {
		const isSelectedData = selectedWeekStart
			? selectedWeekStart?.getTime() === weekData.startDateInclusive.getTime()
			: false;

		return {
			value: weekData.medianIssuesPerDeployment.prod,
			itemStyle: { color: colors.N80 },
			customInfo: {
				startDateInclusive: weekData.startDateInclusive,
				numProdDeployments: weekData.deploymentCount.prod,
				medianProdDeployments: deploymentFrequencyReportData.averageDeploymentCount,
				isSelectedData,
			},
		};
	});
